export const generateRecipeSchemeData = ({
  hero,
  ingredientsData,
  methodData,
  collectionData,
  attributeData,
  breadcrumbData,
}: any) => {
  const { recipeTitle, subtitle, image, rating, ratingCount, cookingDuration } =
    hero;
  const { ingredient } = ingredientsData;
  const { methodListSchema } = methodData;
  let { collections } = collectionData;

  const { attributes } = attributeData;
  collections = collections.filter((item: any) => item.category === 44);

  const keywordsArray = [
    { title: recipeTitle },
    ...collections.slice(1),
    ...attributes.slice(0),
  ].map((item) => {
    return item?.title;
  });

  const keywords = keywordsArray?.join(", ");

  const recipeSchemaData = {
    "@context": "https://schema.org/",
    "@type": "Recipe",
    name: recipeTitle,
    image: image,
    author: {
      "@type": "Organization",
      name: "Shyft",
      url: "http://betheshyft.com/",
    },
    recipeCategory: collections?.[0]?.title || attributes?.[0]?.title,
    // recipeCuisine: attributes?.[0]?.title,
    keywords: keywords,
    description: subtitle,
    recipeYield: 2,
    prepTime: "PT10M",
    cookTime: `PT${cookingDuration}M`,
    totalTime: `PT${cookingDuration + 10}M`,
    url: breadcrumbData[2].url,
    recipeIngredient: ingredient?.map((item: any) =>
      item.title.substring(0, 135)
    ),
    recipeInstructions: methodListSchema?.map(({ item, name }: any) => {
      return {
        "@type": "HowToStep",
        name: name,
        text: item,
      };
    }),
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: parseInt(rating),
      ratingCount: parseInt(ratingCount),
    },
  };

  return recipeSchemaData;
};

export const generateCarouselSchemaData = ({ similarRecipes }: any) => {
  const { similarList } = similarRecipes;

  const carouselData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: similarList.map((item: any, index: number) => {
      const {
        cooking_time,
        cover_image,
        description,
        default_rating,
        rating_count,
        title,
        share_url,
      } = item;
      return {
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Recipe",
          name: title,
          image: cover_image,
          author: {
            "@type": "Organization",
            name: "Shyft",
            url: "http://betheshyft.com/",
          },
          keywords: title,
          description,
          recipeYield: 2,
          prepTime: "PT10M",
          cookTime: `PT${cooking_time}M`,
          totalTime: `PT${cooking_time + 10}M`,
          url: share_url,
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: parseInt(default_rating),
            ratingCount: parseInt(rating_count),
          },
        },
      };
    }),
  };

  return carouselData;
};

export const generateBreadcrumbSchemaData = ({ breadcrumbData = [] }: any) => {
  const breadcrumbSchemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbData.map(({ name, url }: any, index: number) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: name,
        item: url,
      };
    }),
  };

  return breadcrumbSchemaData;
};
